<template>
    <div class="productInfo">
        <headers :title="product.name" :img="product.type"></headers>
        <el-row :gutter="20">
            <el-col :xs="{span:12,offset:5}" :sm="{span:12,offset:5}" :md="{span:5,offset:5}" :lg="{span:5,offset:5}" :xl="{span:5,offset:5}"><div class="mainTitle">{{product.name}}</div></el-col>
            <el-col :xs="{span:6,offset:5}" :sm="{span:6,offset:5}" :md="{span:2,offset:7}" :lg="{span:2,offset:7}" :xl="{span:2,offset:7}"><div class="backBtn" @click="goBack()"><img src="../../public/img/whiteLeft.png" height="60%" alt="" srcset="">{{$t('返回上一级')}}</div></el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="14" :offset="5"><div class="line"></div></el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="14" :offset="5">
                <el-row :gutter="40" type="flex" class="hidden-sm-and-down">
                    <el-col :span="15">
                        <img :src="mainImgRender" width="100%" alt="" srcset="">
                    </el-col>
                    <el-col class="infoText" :span="11" :offset="1">
                        <div>
                            <p class="title">{{product.name}}</p>
                            <div class="line" style="background:#33333333;height:0.5px;"></div>
                            <div class="productInfotext">
                                <div class="text_title">
                                    <img src="../../public/img/productItem/itemInfo/circle.png" alt="" srcset="">
                                    <div>{{$t('产品简介')}}</div>
                                </div>
                                <div class="text_Info">{{product.info.Introduction}}</div>
                            </div>
                            <div class="productInfotext">
                                <div class="text_title">
                                    <img src="../../public/img/productItem/itemInfo/circle.png" alt="" srcset="">
                                    <div>{{$t('产品用途')}}</div>
                                </div>
                                <div class="text_Info">{{product.info.use}}</div>
                            </div>
                            <div class="productInfotext">
                                <div class="text_title">
                                    <img src="../../public/img/productItem/itemInfo/circle.png" alt="" srcset="">
                                    <div>{{$t('颜色款式')}}</div>
                                </div>
                                <div class="color">
                                    <img :src="`${baseUrl}img/productItem/itemInfo/color/${item}`" alt="" srcset="" v-for="(item) in product.info.colors" :key="item">     
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="40" type="flex" class="hidden-sm-and-down">
                    <el-col :span="24">
                        <productInfoBanner  v-on:changeimg="changeBigImg" :imgList="product.info.img" :imgUrl="product.info.imgUrl"></productInfoBanner>
                    </el-col>
                </el-row>
                <el-row :gutter="40" class="hidden-md-and-up">
                    <el-carousel trigger="click" >
                        <el-carousel-item v-for="item in product.info.img" :key="item">
                            <img :src="`${baseUrl}img/productItem/itemInfo/${product.info.imgUrl}/${item}`" width="100%" alt="" srcset="">
                        </el-carousel-item>
                    </el-carousel>
                </el-row>
                <el-row :gutter="40" type="flex" class="hidden-md-and-up">
                    <el-col class="infoText" :span="24" :offset="0" style="margin-bottom:5rem;">
                        <div>
                            <p class="title">{{product.name}}</p>
                            <div class="line" style="background:#33333333;height:0.5px;"></div>
                            <div class="productInfotext">
                                <div class="text_title">
                                    <img src="../../public/img/productItem/itemInfo/circle.png" alt="" srcset="">
                                    <div>{{$t('产品简介')}}</div>
                                </div>
                                <div class="text_Info">{{product.info.Introduction}}</div>
                            </div>
                            <div class="productInfotext">
                                <div class="text_title">
                                    <img src="../../public/img/productItem/itemInfo/circle.png" alt="" srcset="">
                                    <div>{{$t('产品用途')}}</div>
                                </div>
                                <div class="text_Info">{{product.info.use}}</div>
                            </div>
                            <div class="productInfotext">
                                <div class="text_title">
                                    <img src="../../public/img/productItem/itemInfo/circle.png" alt="" srcset="">
                                    <div>{{$t('颜色款式')}}</div>
                                </div>
                                <div class="color">
                                    <img :src="`${baseUrl}img/productItem/itemInfo/color/${item}`" alt="" srcset="" v-for="(item) in product.info.colors" :key="item">     
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <foot></foot>
    </div>
</template>
<script>
import headers from "@/components/headers.vue";
import foot from "@/components/foot.vue";
import productInfoBanner from "@/components/productInfoBanner.vue";
import {productData} from "../datas/productData.js"

export default {
    created(){
        this.render()
    },
    data() {
        return {
            product:{
                name:'',
                img:'',
                type:'',
                info:{
                    Introduction:"",
                    use:"",
                    colors:[],
                    imgUrl:'',
                    img:[]
                }
            },
            baseUrl:process.env.BASE_URL, 
            mainImg:'',
        }
    },
    watch: {
        '$route' (to, from) {
            this.render()
        },
        '$i18n.locale'(){
            this.render()
        },
    },
    computed:{
        mainImgRender(){
            if(this.mainImg==''){
                return `${this.baseUrl}img/productItem/itemInfo/${this.product.info.imgUrl}/0.jpg`
            }else{
                return `${this.baseUrl}img/productItem/itemInfo/${this.mainImg}`
            }
        }
    },
    methods:{
        render(){
            this.product = this.productList(this.$route.params.class,this.$route.params.index,this.$route.params.childIndex)
        },
        changeBigImg(url){
            this.mainImg = url
        },
        productList(className,index,childIndex){
            return productData(className).itemList[index].child[childIndex]
        },
        goBack(){
            this.$root.$router.go(-1)
        }
    },
    components:{
        headers,foot,productInfoBanner
    }
}
</script>
<style lang="less">
.productInfo{
    .mainTitle{
        font-size: 1.5rem;
        margin-top: 3rem;
        color: #444444;
        font-weight: bold;
        white-space:nowrap;
        margin-bottom: 1.5rem;
        
    }
    .line{
        border-bottom: 1px solid #444444;
        margin-bottom: 1.5rem;
        margin-top: 1.5rem;
        
    }
    .backBtn{
        background-color: rgba(1, 124, 168, 0.31);
        font-size: 0.6rem;
        line-height: 1.4rem;
        height: 1.4rem;
        font-weight: 1;
        cursor: pointer;
        border-radius: 1rem;
        img{
            margin-right: 0.3rem;
            flex-grow: 0;
            height: 40%;
            flex-shrink: 0;
            // height: 50%;
        }
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 3.4rem;
        color: #ffffff;
        white-space:nowrap;
        margin-bottom: 1.5rem;
    }
    .infoText{
        // height: 100px;
        // width: 100%;
        // background-color: red;
        // padding: 1;
        .title{
            color: #017CA8;
            font-weight: bold;
            font-size: 1.1rem;
            line-height: 1rem;
            height: 1rem;
        }
        .productInfotext{
            .text_title{
                display: flex;
                align-items: center;
                justify-content: flex-start;
                color: #4C4C4C;
                font-size: 0.7rem;
                font-weight: bold;
                margin-top: 1rem;
                img{
                    margin-right: 1rem;
                    width: 0.4rem;
                }
            }
            .text_Info{
                margin-left: 1.4rem;
                font-size: 0.6rem;
                line-height: 1.5rem;
                color: #4C4C4C;
                margin-top: 0.5rem;
            }
            .color{
                display: flex;
                margin-top: 0.8rem;
                margin-left: 1.4rem;
                img{
                    margin-right: 1.5rem;
                    height: 1rem;
                }
            }
        }
    }
}
</style>

